import { APIClient } from "./axiosClient";

export class ShippingProfileApi {
  static fetchShippingProfiles(payload) {
    return APIClient(
      "/shippingProfile/getShippingProfiles",
      payload,
      { requestType: "post" }
    );
  }

  static fetchAllCountries() {
    return APIClient("/shippingProfile/getAllCountries");
  }

  static fetchShippingProfile(id) {
    return APIClient(`/shippingProfile/getShippingProfileById?id=${id}`);
  }

  static createOrUpdateShippingProfile(payload) {
    return APIClient(
      "/shippingProfile/createOrUpdateShippingProfile",
      payload,
      { requestType: "post" }
    );
  }
} 